/*
 * c-slider-boot.js
 *
 * Loaded with defer from snippets/c-slick-libs.liquid, immediately after
 * jquery.min.js and slick.min.js. Deferred scripts execute in document order
 * once parsing has finished, so by the time this runs both libraries are in
 * place and the whole DOM exists.
 *
 * Sections queue their slider setup with cWhenSlick(fn) (see
 * snippets/c-slick-init.liquid); this releases the queue.
 */
(function () {
  if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) {
    console.error('[c-slick] jQuery or Slick failed to load; sliders will not start.');
    return;
  }
  if (typeof window.cSlickDrain === 'function') {
    window.cSlickDrain();
  } else {
    // No consumer rendered on this page. Mark ready so any late caller runs.
    window.cSlickReady = true;
  }
}());
